module.exports = __webpack_public_path__ + "fonts/SegoeUI-SemiBold.b58d700f.woff";